<template lang="html">
  <div id="text-page">
    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <h1 class="mb-2 text-center page-title">Políticas de contratación</h1>

      <p class="f-w-600">
        Transparencia en nuestro proceso de selección.
      </p>
      <p>
        En Marquez Express Inc., con domicilio en 503 Interamerica Blvd, Laredo, TX 78045, USA, creemos en procesos claros y sin compromisos anticipados. Estas políticas aplican al registro realizado a través de nuestro sitio web.
      </p>

      <br />
      <h6>1. Registro de interesados</h6>
      <p>
        El formulario disponible en www.iamarquez.com está diseñado para recibir información de personas interesadas en colaborar con nuestra operación logística.
      </p>

      <br />
      <h6>2. Sin compromiso de contratación</h6>
      <p>
        El envío de información no constituye una oferta ni un compromiso de contratación por parte de Marquez Express Inc.<br />
        Toda solicitud será evaluada conforme a nuestros criterios internos y necesidades específicas.
      </p>

      <br />
      <h6>3. Contacto sujeto a validación</h6>
      <p>
        Nos reservamos el derecho de contactar únicamente a los perfiles que cumplan con requisitos como:
      </p>
      <ul>
        <li>Tipo de visa y licencia</li>
        <li>Años de experiencia</li>
        <li>Condiciones del vehículo</li>
        <li>Disponibilidad y ubicación</li>
      </ul>

      <br />
      <h6>4. Uso responsable</h6>
      <p>
        La información enviada será utilizada exclusivamente para evaluación interna. No será compartida con terceros y se manejará con total confidencialidad.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/privacidad')).then((response)=>{
        this.content = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
